import { isAdmin as getIsAdminUser, isQualityUser as getIsQualityUser, isSuperUser as getIsSuperUser } from 'selectors/user'
import { useSelector } from 'react-redux'

export const isAdminRole = () => {
    const isAdminUser = useSelector(getIsAdminUser)
    return isAdminUser
}

export const isSuperUserRole = () => {
    const isSuperUser = useSelector(getIsSuperUser)
    return isSuperUser
}

export const isQualityUserRole = () => {
    const isQualityUser = useSelector(getIsQualityUser)
    return isQualityUser
}

export const isReadOnlyUser = () => {
    const isQualityUser = useSelector(getIsQualityUser)
    const isAdminUser = useSelector(getIsAdminUser)
    const isReadOnlyUser = !isAdminUser && !isQualityUser
    return isReadOnlyUser
}